import type {Component} from 'typings/portaro.fe.types';
import type {ModalWindowBindings, ModalWindowResolveValues} from '../conversation';
import type {IOnInit} from 'angular';
import type {ViewableSettingChain} from 'typings/portaro.be.types';



export interface SettingsModalModel {
    settings: ViewableSettingChain[];
    message: string;
}

export default class SettingsModalComponent implements Component<ModalWindowBindings<SettingsModalModel>> {
    public static componentName = 'settingsModal';

    public bindings = {
        resolve: '<'
    } as const;
    public controller = SettingsModalController;
    public templateUrl = require('./settings-modal.tpl.ftl');
}

class SettingsModalController implements ModalWindowBindings<SettingsModalModel>, IOnInit {
    public static controllerName = 'settingsModalController';

    public resolve: ModalWindowResolveValues<SettingsModalModel>;

    public settings: ViewableSettingChain[];
    public message: string;

    public $onInit() {
        this.settings = this.resolve.model.settings;
        this.message = this.resolve.model.message;
    }

    public close() {
        this.resolve.modalWindowActions.acknowledge();
    }
}